<template lang="html">
  <div id="reset" class="reset row">
      <div class="col-lg-3"></div>
      <div class="col-lg-9">
        <RegLoginHeader/>
      </div>
    <div class="col-lg-12">
      <div v-if="loader" class="loader"></div>
      <form @submit.prevent="resetPassword" novalidate>
        <div class="row">
          <div class="col-lg-4"></div>
          <div class="col-lg-4">
            <h1 class="text-center">{{translation.button.resetPass}}</h1>
            <div class="card-conteiner">
              <p class="text-left">
                <span>{{translation.registration.requiredField}}</span>
                <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
                <span>{{translation.registration.areRequired}}</span>
              </p>
              <div class="form-group text-left">
                <div :class="{ requiredField: requiredEmail }">
                  <input type="email" class="form-control" name="reset-email"
                       id="user-reset-email" :placeholder="translation.registration.email + translation.registration.requiredSymbol" v-model="response.email">
                       <label for="reset-email">{{translation.registration.email + translation.registration.requiredSymbol}}</label>
                </div>
              </div>
              <div class="form-group text-left">
                <div :class="{ requiredField: requiredPassword }">
                  <input :type="type" class="form-control" name="reset-password"
                       id="user-reset-password" :placeholder="translation.registration.newPass + translation.registration.requiredSymbol" v-model="response.password">
                       <label for="reset-password">{{translation.registration.newPass + translation.registration.requiredSymbol}}</label>
                </div>
                <span class="show-pass" @click="showPassword"><img class="img-responsive" src="../../assets/img/icons/eye-password.svg" alt="eye-password.svg"></span>
              </div>
              <p v-if="errors.length" class="text-left text-danger">
                <b>{{translation.registration.correct}}:</b>
                <ul class="list-group">
                  <li class="text-danger text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
                </ul>
              </p>
              <p v-if="sendEmail" class="text-left text-success">
                <b>{{translation.updateProfile.sendEmail}}</b>
              </p>
              <button type="submit" class="btn btn-primary login-button">{{translation.button.submit}}</button>
            </div>
          </div>
          <div class="col-lg-4"></div>
        </div>
      </form>
    </div>
    <div class="col-lg-12">
      <Footer/>
    </div>
  </div>
</template>

<script>
import RegLoginHeader from '../../components/RegLoginHeader.vue';
import Footer from '../../components/Footer.vue';
export default {
  data(){
    return {
      translation: null,
      errors: [],
      loader: false,
      sendEmail: false,
      type: 'password',
      requiredEmail: false,
      requiredPassword: false,
      response: {
        email: null,
        password: null,
        role: '',
        langCode: 'bg_BG'
      }
    }
  },
  components:{
    RegLoginHeader,
    Footer
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  methods:{
    validate: function (e) {
      this.errors = [];
      if (!this.response.email) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.email + '" ' +
          this.translation.registration.required
        );
        this.requiredEmail = true;
      } else if (!this.validEmail(this.response.email)) {
        this.errors.push(this.translation.registration.validEmail);
        this.requiredEmail = true;
      }
      if (!this.response.password) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.password + '" ' +
          this.translation.registration.required
        );
        this.requiredEmail = true;
      }else if (this.response.password.length < 6) {
        this.errors.push(
          this.translation.registration.passwordLenthError
        );
        this.requiredEmail = true;
      }
      if (!this.errors.length) {
        return true;
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    resetPassword: function(e){
      if (this.validate(e)) {
        this.loader = true;
        this.response.role = this.$route.params.role;
        var formData = this.toFormData(this.response);
        var self = this;
        axios.post('reset-password', formData)
        .then(function(response){
          self.loader = false;
          if (response.data.success && response.data.result.serverMessage) {
            var checkError = response.data.result.serverMessage;
            if (checkError == 'emptyEmail') {
              self.errors.push(self.translation.serverError.emptyEmail);
            }else if (checkError == 'validEmail') {
              self.errors.push(self.translation.serverError.validEmail);
            }else if (checkError == 'emptyPassword') {
              self.errors.push(self.translation.serverError.emptyPassword);
            }else if (checkError == 'passwordLengt') {
              self.errors.push(self.translation.serverError.passwordLengt);
            }
          }else {
            self.sendEmail = true;
          }
        })
        .catch(err => err)
      }
    },
    showPassword() {
       if(this.type === "password") {
          this.type = "text";
       } else {
          this.type = "password";
       }
     },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style>
#reset .form-group{
  position: relative;
  margin-top: 2em;
}
#reset{
  background: #FFF;
  background-image: url('../../assets/img/backgrounds/hedyr-login-refistration.jpg');
  background-repeat:no-repeat;
  position: relative;
}
@font-face {
  font-family: 'Montserrat-Black';
  src: url("../../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#reset .blue-paw{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 15%;
}
#reset h1{
  margin-top: 1em;
  margin-bottom: 1em;
  color: #fff;
  font-family: 'Montserrat-Black';
}
#reset .forgot-pass{
  font-size: .7em;
  text-align: left;
  margin-bottom: 1em;
}
#reset .login-button{
  background: #FE7154;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border: none;
  outline: none;
  border-radius: 5em;
  margin-top: 1em;
  margin-bottom: 1em;
}
#reset .footer {
  margin-top: 15em;
  margin-left: 3em;
  color: #707070;
}
#reset .footer .footer-menu a {
  color: #707070;
}
#reset .footer .col-lg-7{
  text-align: center!important;
}
 #reset input[type=text],
 #reset input[type=password],
 #reset input[type=email]
 {
  color: #707070!important;
  background: none!important;
  border: none!important;
  border-radius: 0!important;
  outline: none!important;
  border-bottom: 2px solid #707070!important;
  width: 100%;
  outline: none!important;
  box-shadow: none !important;
}
#reset label {
  display: none;
}
#reset input[type=text]:focus,
#reset input[type=password]:focus,
#reset input[type=email]:focus
{
  border-bottom: 2px solid #3057B0!important;
  outline:0px !important;
  -webkit-appearance:none;
  box-shadow: none !important;
}
#reset input[type=text]:focus + label ,
#reset input[type=password]:focus + label,
#reset input[type=email]:focus + label
{
   display: block;
   position: absolute;
   bottom: 2em;
   color: #212121!important;
   font-size: 1em;
}

#reset input[type=text]:focus::-webkit-input-placeholder,
#reset input[type=password]:focus::-webkit-input-placeholder,
#reset input[type=email]:focus::-webkit-input-placeholder
{
  color:transparent;
}
#reset input[type=text]::-moz-placeholder
#reset input[type=password]:focus::-moz-placeholder
#reset input[type=email]:focus::-moz-placeholder {
  color:transparent;
}
#reset input[type=text]:focus::-moz-placeholder
#reset input[type=password]:focus::-moz-placeholder
#reset input[type=email]:focus::-moz-placeholder {
   color:transparent;
 }
 #reset input[type=text]:focus::-ms-input-placeholder
 #reset input[type=password]:focus::-ms-input-placeholder
 #reset input[type=email]:focus::-ms-input-placeholder {
  color:transparent;
}
.list-group-item{
  border: none;
  background: none;
  padding-left: 0;
  font-size: .8em;
}
#reset .requiredField input{
  border-bottom: 2px solid #F82727!important;
}
#reset .requiredField label{
  color: #F82727!important;
  opacity: 1;
}
#reset .page {
  margin-top: 1em;
}
@font-face {
  font-family: 'Raleway-Medium';
  src: url("../../assets/fonts/Raleway-Medium.woff") format("woff");
  font-display: swap;
}
#reset {
  font-family: 'Raleway-Medium';
}
@font-face {
  font-family: 'Montserrat-Medium', sans-serif;
  src: url("../../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#reset .tabs .nav-link{
  color: #131313;
}
#reset .tabs .nav-link.active{
  color: #3057B0;
  font-family: 'Montserrat-Medium', sans-serif;
}
#reset .show-pass img{
  width: 1em;
  position: absolute;
  right: 0;
  top: 0;
}
#reset .show-pass img:hover{
  cursor: pointer;
}
#reset  .user-icon img,
#reset  .vet-icon img
 {
  width: 2em;
}
</style>
